export const ValidationMessage = ({ error }: { error?: string | { message?: string } }) => {
    if (!error) return null;

    const message = typeof error === "string" ? error : error.message;
    if (!message) return null;

    return <div className="text-sm text-red-500">{message}</div>;
};
